import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import Button from '@react/react-spectrum/Button';
import Heading from '@react/react-spectrum/Heading';
import Label from '@react/react-spectrum/Label';

import QuickSetupIcon from '@react/react-spectrum/Icon/Launch';
import ApplyConfigurationIcon from '@react/react-spectrum/Icon/Alert';

import { PATHS } from 'config/constants';
import { useAEP } from 'data/hooks';
import { useSidebar } from 'views/App';
import SandboxStatus from 'components/SandboxStatus';

const PROD_SANDBOX_NAME = 'prod';

export default function ConfigureControls({ id, sandboxName }) {
  const history = useHistory();
  const { hide: closeSidebar } = useSidebar();
  const { loading, error, data } = useAEP(id, {
    details: true
  });

  const actionsEnabled = useMemo(() => {
    return (
      !loading &&
      !error &&
      (sandboxName === PROD_SANDBOX_NAME ||
        data?.aep?.details?.state === 'active')
    );
  }, [sandboxName, loading, error, data]);

  const handleApplyConfigurationClick = () => {
    history.push(PATHS.AEP_CONFIGURE);
    closeSidebar();
  };

  const handleQuickSetupClick = () => {
    history.push(PATHS.QUICK_SETUP);
    closeSidebar();
  };

  return (
    <div>
      <section>
        <div className="operation-message">
          <SandboxStatus loading={loading} error={error} data={data} />
        </div>
      </section>

      <div>
        <section>
          <Heading variant="subtitle1">Actions</Heading>

          <Button
            label="Quick Setup"
            icon={<QuickSetupIcon />}
            onClick={handleQuickSetupClick}
            disabled={!actionsEnabled}
            quiet
          />
        </section>
      </div>
    </div>
  );
}
